import { CSSProperties } from 'react';
import { colors } from '../../NewHire/v2/styles';

interface RatingScaleProps {
  value: number | undefined;
  onChange: (value: number) => void;
}

const optionBase: CSSProperties = {
  flex: 1,
  textAlign: 'center',
  padding: '10px 6px',
  border: `1px solid ${colors.border}`,
  background: '#fff',
  borderRadius: 8,
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 600,
  color: colors.text,
};

const selectedStyle: CSSProperties = {
  borderColor: colors.accent,
  background: colors.accentSoft,
  color: '#1E3A8A',
};

const RatingScale = ({ value, onChange }: RatingScaleProps) => {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      {[1, 2, 3, 4, 5].map((n) => {
        const isSelected = value === n;
        return (
          <button
            type="button"
            key={n}
            onClick={() => onChange(n)}
            style={{ ...optionBase, ...(isSelected ? selectedStyle : {}) }}
          >
            {n}
          </button>
        );
      })}
    </div>
  );
};

export default RatingScale;
